import EntryBar from './EntryBar';

export default function HeroSection() {
  return (
    <section id="top" className="relative bg-background-50 overflow-hidden">
      <div className="pointer-events-none absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-accent-100/70 blur-3xl"></div>
      <div className="relative px-4 md:px-6 pt-10 md:pt-16 pb-10 md:pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7 xl:col-start-1 xl:col-end-8 xl-fade-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
              <span className="text-xs font-label font-medium">小蓝视频 · 主播与内容浏览指南</span>
            </div>

            <h1 className="font-heading font-black text-foreground-950 leading-[1.15] text-3xl md:text-5xl">
              小蓝视频主播与热门内容浏览指南
              <span className="text-primary-600">：短视频、直播、福利资源一网打尽</span>
            </h1>

            <p className="mt-5 md:mt-6 text-sm md:text-base leading-relaxed text-foreground-600 max-w-2xl">
              这份指南帮你快速了解小蓝视频的主播生态与热门内容，覆盖短视频、直播、福利资源等分类。无论你想找感兴趣的主播还是发掘近期高热度内容，都能按图索骥，减少盲目翻找的时间。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-base"></i>
                先看近期热门内容
              </a>
              <a
                href="#anchors"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-label font-medium hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-user-star-line text-base"></i>
                按主播查找
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 xl:col-span-5 xl:col-start-8 relative">
            <div className="relative w-full aspect-[9/11] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20warm-toned%20creative%20video%20studio%20scene%20with%20camera%20and%20softbox%20silhouettes%2C%20soft%20coral%20and%20amber%20rim%20lighting%2C%20floating%20light%20particles%2C%20abstract%20cinematic%20backdrop%2C%20no%20text%2C%20high%20detail%20and%20harmonious%20magazine%20composition&width=900&height=1100&seq=xl-hero-01&orientation=portrait"
                alt="小蓝视频 内容浏览指南主视觉"
                title="小蓝视频主播与热门内容浏览指南"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
              <div className="absolute left-4 right-4 bottom-4">
                <p className="text-[11px] font-label text-background-200/90">今晚精选封面</p>
                <p className="mt-1 font-heading text-lg font-bold text-background-50">
                  深夜电台 · 城市漫游 · 音乐现场
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {['短视频', '直播', '福利资源'].map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 rounded-full bg-background-50/20 backdrop-blur text-xs font-label text-background-50"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="xl-float absolute -left-4 bottom-8 hidden sm:block rounded-lg border border-background-200 bg-background-50 px-4 py-3 shadow-none">
              <p className="text-xs font-label text-foreground-500">今日新增</p>
              <p className="font-heading text-2xl font-black text-primary-600 leading-none mt-1">36</p>
              <p className="text-xs font-label text-foreground-500 mt-0.5">条内容待浏览</p>
            </div>

            <div className="absolute -right-3 top-8 hidden md:flex flex-col items-center gap-1 rounded-lg bg-accent-500 text-background-50 px-3 py-3">
              <i className="ri-live-line text-xl"></i>
              <span className="text-[10px] font-label whitespace-nowrap">12 位在线</span>
            </div>
          </div>
        </div>

        <div className="mt-9 md:mt-12">
          <EntryBar />
        </div>
      </div>
    </section>
  );
}